import Errors from '@/Errors'

export default ({ $axios, redirect, app, store, $bugsnag }, inject) => {
  $axios.onError((error) => {
    if (error.response === undefined) {
      throw error
    }

    const errorResponse = new Errors().setAndParse(error)
    store.commit('snackbar/showMessage', { content: errorResponse, color: 'error' })

    if ($bugsnag?.notify) {
      $bugsnag.notify(error, (event) => {
        event.addMetadata('api', {
          message: errorResponse.message,
          status: error.response.status,
          method: error.config?.method,
          url: error.config?.url
        })
      })
    }
    throw error
  })
}
